module.exports = __webpack_public_path__ + "img/add-user-group-man-man.bbe80659.png";